import Vue from 'vue';
import VueI18n from 'vue-i18n';
import geti18nConfig from '../plugin/filter/vue-i18n-config';
import { getLanguage } from './system';

const language = getLanguage('ko');
Vue.use(VueI18n);
export const i18n = geti18nConfig(language);
